import React from "react"

export type ShadeRoundProps = {
    isLittle: boolean
    color: string | string[] | null
}

const ShadeRound: React.FC<ShadeRoundProps> = ({ isLittle, color }) => {
    const size = isLittle ? 12 : 44

    const colors = Array.isArray(color) ? color.slice(0, 4) : [color || "black"]

    const quadrantStyle = (index: number): React.CSSProperties => {
        const base: React.CSSProperties = {
            position: "absolute",
            width: "50%",
            height: "50%",
        }

        // Clockwise starting from top-left
        switch (index) {
            case 0: // top-left
                return { ...base, top: 0, left: 0, backgroundColor: colors[0] || "transparent" }
            case 1: // top-right
                return { ...base, top: 0, right: 0, backgroundColor: colors[1] || "transparent" }
            case 2: // bottom-right
                return { ...base, bottom: 0, right: 0, backgroundColor: colors[2] || "transparent" }
            case 3: // bottom-left
                return { ...base, bottom: 0, left: 0, backgroundColor: colors[3] || "transparent" }
            default:
                return {}
        }
    }

    return (
        <div
            style={{
                width: size,
                height: size,
                borderRadius: "50%",
                position: "relative",
                overflow: "hidden",
                outline: "none",
            }}
        >
            {colors.length === 1 ? (
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        backgroundColor: colors[0],
                        borderRadius: "50%",
                    }}
                />
            ) : (
                <>
                    {[0, 1, 2, 3].map(i => (
                        <div key={i} style={quadrantStyle(i)} />
                    ))}
                </>
            )}
        </div>
    )
}

export default ShadeRound